import { render } from "./leftMenu.vue?vue&type=template&id=3a2f5793"
import script from "./leftMenu.vue?vue&type=script&lang=js"
export * from "./leftMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__